import fetch from 'utils/fetch';
import qs from 'querystring';
import hex_sha1 from 'sha1';

export function getAdminUserList(pageNum, pageSize, searchStr, agId) {
    const data = qs.stringify({
        pageNum,
        pageSize,
        searchStr,
        agId
    });
    return fetch({
        url: '/av1/admin/getAdminUserList',
        method: 'post',
        data
    });
}

export function updateUserState(ubInfoId, state) {
    const data = qs.stringify({
        ubInfoId,
        state
    });
    return fetch({
        url: '/av1/admin/updateUserState.ajax',
        method: 'post',
        data
    });
}

export function getAdminGroup() {
    return fetch({
        url: '/av1/auth/userAuthGp',
        method: 'post'
    });
}

export function editAdminUser(ubInfoId, uName, uImage) {
    const data = qs.stringify({
        ubInfoId,
        uName,
        uImage
    });
    return fetch({
        url: '/av1/admin/editBackgroundUserAjax.ajax',
        method: 'post',
        data
    });
}

export function changeUserGroup(userId, authGpId) {
    const data = qs.stringify({
        userId,
        authGpId
    });
    return fetch({
        url: '/av1/auth/changeUserAuth',
        method: 'post',
        data
    });
}

export function addBackGroundUser(uName, uEmail, uPwd, uImage) {
    const data = qs.stringify({
        uName,
        uEmail,
        uPwd: hex_sha1(uPwd),
        uImage
    });
    return fetch({
        url: '/av1/admin/addBackgroundUser.ajax',
        method: 'post',
        data
    });
}
export function changePass(oldpass,newpass) {
    const data = qs.stringify({
        oldpass: hex_sha1(oldpass),
        newpass: hex_sha1(newpass)
    });
    return fetch({
        url: '/av1/admin/chpwd',
        method: 'post',
        data
    });
}



// WEBPACK FOOTER //
// ./src/api/adminUser.js